// @ts-strict-ignore
import React from 'react'
import { createPortal } from 'react-dom'
import { Box } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/ThemeLottie'

export const ContactsSearchListLoader = () => {
  return (
    <>
      {createPortal(
        <Box
          flexCol
          width="full"
          minHeight="screen"
          centerChildren
          gap={20}
          className="bg-[#FFFEFA]/10 shadow-lg shadow-black/10 fixed z-[80] backdrop-blur"
        >
          <Box className="-translate-y-40 transform">
            <Lottie src="app-loader" width={80} height={80} />
          </Box>
        </Box>,
        document.querySelector('[data-radix-scroll-area-viewport]')
      )}
    </>
  )
}
